import React from 'react'

function Home() {

	return (
		<div style={{width: '1080px', height: '1920px', background: 'black', color: 'white', textAlign: 'center', overflow: 'hidden', position: 'absolute'}}>
		</div>
	)
}

export default Home
